module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-weapon7.png?7ff56e80";